module.exports = __webpack_public_path__ + "static/media/play-store.e78ff1ac.png";